export default __webpack_public_path__ + "static/media/WhiteLand.298d24a8.png";